import * as React from 'react'
import { Modal } from 'reactstrap'

import './styles.scss'
import { surveys as surveysApi } from 'api'
import ModalWrapper from 'components/ModalWrapper'
import { BrandsAndDelegations, SelectWithLabel, Button } from 'components/Form'
import PhoneViewer from 'components/PhoneViewer'
import { getStaticImage } from 'utils/statics'
import dkvConfiguration from 'constants/dkv.constants'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { lang } from 'utils/helpers'

const SurveyDetail = (props) => {
  const { isOpen, toggle, save, valuesToEdit, variables, isSubmitting, errorMessageModal, setErrorMessageModal } = props
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [survey, setSurvey] = React.useState({})
  const [disabled, setDisabled] = React.useState(true)
  const variablesLabels = {
    'operator.email'      : lang('dashboard_operator-email'),
    'operator.fullName'   : lang('dashboard_operator-full-name'),
    'operator.role'       : lang('dashboard_operator-rol'),
    'user.email'          : lang('dashboard_user-email'),
    'user.phone'          : lang('dashboard_user-phone'),
    'user.id'             : lang('dashboard_user-id'),
    'user.brandName'      : lang('dashboard_user-brand'),
    'user.delegationName' : lang('dashboard_user-delegation')
  }
  const typeOptions = [
    {
      value: 'operatorEmail',
      label: lang('dashboard_operator-email')
    },
    {
      value: 'clientId',
      label: lang('dashboard_customer-id')
    }
  ]
  const [type, setType] = React.useState(typeOptions[0])
  const [variablesSelectorOptions, setVariablesSelectorOptions] = React.useState([])
  const [variablesSelectorValues, setVariablesSelectorValues] = React.useState([])
  const [isOpenPreviewModal, setIsOpenPreviewModal] = React.useState(false)
  const [currentChannelPreview, setCurrentChannelPreview] = React.useState(undefined)

  React.useEffect(() => {
    if (variables) {
      const variablesOptions = []

      variables.forEach(variable => variablesOptions.push({
        value: variable,
        label: variablesLabels[variable]
      }))

      setVariablesSelectorOptions(variablesOptions)
    }
  }, [variables])

  React.useEffect(() => {
    const convertedVariables = []

    variablesSelectorValues.forEach(variable => {
      convertedVariables.push({
        name: variable.name,
        field: variable.value
      })
    })

    setSurvey(prevState => ({ ...prevState, variables: convertedVariables }))
  }, [variablesSelectorValues])

  React.useEffect(() => {
    if (valuesToEdit._id) {
      surveysApi.getById(valuesToEdit._id).then(({ data }) => {
        setSurvey(data)
        setBrands(data.brands)
        setDelegations(data.delegations)
        setType(
          data.type === 'operatorEmail'
            ? typeOptions[0]
            : typeOptions[1]
        )
        if (data.variables) {
          const variables = []
          data.variables.forEach(variable => variables.push({
            value: variable.field,
            label: variablesLabels[variable.field],
            name: variable.name
          }))
          setVariablesSelectorValues(variables)
        }
      }).catch(error => {
        console.error(error)
      })
    }
  }, [valuesToEdit])

  React.useEffect(() => {
    setErrorMessageModal(null)
  }, [brands, delegations, survey])

  const togglePreviewModal = () => setIsOpenPreviewModal(!isOpenPreviewModal)

  const onChangeRefBrandsDelegations = (values) => {
    if (values) {
      let allowEdit = false

      if (values.brands && values.brands.length > 0) {
        values.brands.forEach(it => {
          if (it.isFixed) {
            allowEdit = true
          }
        })
      }

      if (values.delegations && values.delegations.length > 0) {
        values.delegations.forEach(it => {
          if (it.isFixed) {
            allowEdit = true
          }
        })
      }

      setDisabled(allowEdit)
    }
  }

  const handleRemoveVariable = ({ variableIndex }) => {
    const newVariables = [...variablesSelectorValues]
    newVariables.splice(variableIndex, 1)
    setVariablesSelectorValues(newVariables)
  }

  const onClick = () => {
    survey['brands'] = brands
    survey['delegations'] = delegations
    survey['type'] = type.value

    if (!survey || !survey.brands || !survey.brands.length) {
      return setErrorMessageModal(lang('dashboard_errors_you-must-select-brand'))
    }
    if (!survey || !survey.delegations || !survey.delegations.length) {
      return setErrorMessageModal(lang('dashboard_errors_you-must-select-delegation'))
    }
    if (!survey || !survey.name || !survey.name.length) {
      return setErrorMessageModal(lang('surveys_error_required_name'))
    }
    if (!survey || !survey.identifier || !survey.identifier.length) {
      return setErrorMessageModal(lang('surveys_error_required_identifier'))
    }
    if (dkvConfiguration.isDKV) {
      if (!survey || !survey.type || !survey.type.length) {
        return setErrorMessageModal(lang('surveys_error_required_type'))
      }
    }
    if (!survey || (survey.variables && survey.variables.some(variable => !variable.name || !variable.field))) {
      return setErrorMessageModal(lang('dashboard_variable-type-name-required'))
    }

    save(survey)
  }

  return (
    <Modal id='surveyModal' centered isOpen={isOpen} toggle={toggle} contentClassName='modal-content-surveys'>
      <div className='modal-wrapper-header'>
        <h1>{survey._id ? lang('dashboard_edit-survey') : lang('dashboard_add-survey')}</h1>
        <span onClick={toggle}>
          <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
        </span>
      </div>
      <legend dangerouslySetInnerHTML={{ __html:survey._id ? lang('surveys_edit_survey_legend') : lang('surveys_add_survey_legend') }}/>
      <BrandsAndDelegations
        onChangeBrands={value => setBrands(value, 'brand')}
        currentBrands={brands || []}
        onChangeDelegations={value => setDelegations(value, 'delegation')}
        currentDelegations={delegations || []}
        grouped={false}
        setRefBrandsDelegations={onChangeRefBrandsDelegations}
      />
      <div className='surveys-fields-container'>
        <div className='input'>
          <label>{lang('dashboard_survey-name')}</label>
          <input className='input-modal' type='text' defaultValue={survey.name} onChange={(value) => setSurvey({ ...survey, name: value.target.value })} disabled={disabled} />
        </div>
        <div className='input'>
          <label>{lang('dashboard_identifier')}</label>
          <input className='input-modal' type='text' defaultValue={survey.identifier} onChange={(value) => setSurvey({ ...survey, identifier: value.target.value })} disabled={disabled} />
        </div>
      </div>
      <div className='surveys-fields-container'>
        {
          dkvConfiguration.isDKV ? (
            <div className='input'>
              <label>{lang('dashboard_type')}</label>
              <SelectWithLabel
                options={typeOptions}
                value={type}
                onChange={(value) => { setType(value); setSurvey({ ...survey,  type: value.value }) }}
                classNameWrapper='survey-selector'
              />
            </div>
          ) : null
        }
        <div className='input'>
          <label>{lang('surveys_input_buttonLabel_label')}</label>
          <input className='input-modal' type='text' defaultValue={survey.buttonLabel} onChange={(value) => setSurvey({ ...survey, buttonLabel: value.target.value })} disabled={disabled} />
        </div>
      </div>
      <div className='input'>
        <label>{lang('surveys_input_content_label')}</label>
        <TextEditor2
          id='survey-content'
          value={survey.contentHtml || survey.content || ''}
          options={['preview', 'emojis']}
          channel='whatsapp'
          onChange={data => {
            if (data.value || data.valueHtml) {
              setSurvey({
                ...survey,
                content: data.value,
                contentHtml: data.valueHtml
              })
            }
          }}
          isTemplateValue
          onPreviewMsg={togglePreviewModal}
          currentChannelPreview={currentChannelPreview}
          minHeight={150}
          maxHeight={null}
        />
      </div>
      <div className='input'>
        <label>{lang('surveys_input_variables_label')}</label>
        {variablesSelectorValues.length ? (
          <div className='survey-content-variables'>
            {variablesSelectorValues.map((variable, index) => (
              <div className='survey-variable' key={index}>
                <input
                  className='input-modal input-modal--variable-input'
                  type='text'
                  value={variable.name || ''}
                  onChange={event => {
                    const whiteSpaces = /(\s)/.test(event.target.value)

                    if (!whiteSpaces) {
                      setVariablesSelectorValues(Object.assign([...variablesSelectorValues], {
                        [index]: { ...variablesSelectorValues[index], name: event.target.value }
                      }))
                    }
                  }}
                  disabled={disabled}
                />
                <SelectWithLabel
                  placeholder={lang('dashboard_select')}
                  options={variablesSelectorOptions}
                  value={variable.label ? variable : ''}
                  onChange={value => setVariablesSelectorValues(prevState => Object.assign([...prevState], {
                    [index]: { ...prevState[index], ...value }
                  }))}
                  classNameWrapper='survey-selector'
                />
                <button
                  className='survey-variable-remove-btn'
                  onClick={() => handleRemoveVariable({ variableIndex: index })}
                >
                  <i className='fa fa-minus-circle'></i>
                </button>
              </div>
            ))}
          </div>
        ) : null}
        <Button
          clearPrimary
          icon={<i className="fa fa-plus-circle"></i>}
          value={lang('dashboard_add-variable')}
          onClick={() => setVariablesSelectorValues(prevState => ([
            ...prevState,
            {
              value: '',
              label: '',
              name: ''
            }
          ]))}
        />
      </div>
      {errorMessageModal && <small className='error'>{errorMessageModal}</small>}
      <div className='wrapper-buttons'>
        <Button
          secondary={true}
          value={lang('dashboard_save')}
          onClick={onClick}
          isSubmitting={isSubmitting}
        />
        <Button
          value={lang('dashboard_cancel')}
          onClick={toggle}
        />
      </div>

      <ModalWrapper
        isOpen={isOpenPreviewModal}
        toggle={togglePreviewModal}
        header={lang('dashboard_preview')}
        body={
          <div className='modal-content'>
            <PhoneViewer
              textPreview={{
                content: survey.content,
                contentHtml: survey.contentHtml
              }}
              setCurrentChannelPreview={setCurrentChannelPreview}
            />
          </div>
        }
        eventBtnTxt={lang('dashboard_close')}
        eventBtn={togglePreviewModal}
        contentClassName='modal-content-phone-preview'
      />
    </Modal>
  )
}

export default SurveyDetail
